module.exports = __webpack_public_path__ + "static/media/48277541_2309073455834499_7378107013928058880_o.8c8b6fae.jpg";